import React, { useEffect, useState, createContext, useContext } from "react";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Register from "../pages/admin/Register";
import Layout from "../components/layout";
import { useAppContext } from "../context/appContext";
import Login from "../pages/client/Login";
import Report from "../pages/client/Report";
import ViewReport from "../pages/client/viewReport";
import ResetPassword from "../pages/client/ResetPassword";

// Create a context to manage unsaved changes
const UnsavedChangesContext = createContext();

export const useUnsavedChanges = () => {
  return useContext(UnsavedChangesContext);
};

const Routers = () => {
  const { UserType, isAuthenticated } = useAppContext();
  const [currentUser, setCurrentUser] = useState(null);
  const [isChangesInCreateReport, setIsChangesInCreateReport] = useState(false);



  return (
    <UnsavedChangesContext.Provider
      value={{ isChangesInCreateReport, setIsChangesInCreateReport }}
    >
      <Layout>
        <Routes>
          {/* Public Routes */}
          {!isAuthenticated ? (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Navigate to="/report" />} />
              <Route path="/home" element={<Navigate to="/report" />} />
              <Route path="/report" element={<Report />} />
              <Route
                path="/report/:managereportId"
                element={<ViewReport />}
              />
            </>
          )}
        </Routes>
      </Layout>
    </UnsavedChangesContext.Provider>
  );
};

export default Routers;
